import { render, staticRenderFns } from "./wrapperObjectiveBonusList.vue?vue&type=template&id=ac483312&"
import script from "./wrapperObjectiveBonusList.vue?vue&type=script&lang=js&"
export * from "./wrapperObjectiveBonusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports